"use strict";
/**
 * Created on 10 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * General representation of key encapsulating validity (of something) and id of {@link GroupOfSites group of sites}.
 * <br/>
 * You can use this triplet as a key of immutable map or as a value of immutable set.
 * @author JMe
 */


var ValidityGroupOfSitesKey =
/*#__PURE__*/
function () {
  /**
   * @param validFrom validity start date
   * @param validTo validity end date
   * @param groupOfSitesId id of {@link GroupOfSites group of sites}
   */
  function ValidityGroupOfSitesKey(validFrom, validTo, groupOfSitesId) {
    _classCallCheck(this, ValidityGroupOfSitesKey);

    this.validFrom = validFrom;
    this.validTo = validTo;
    this.groupOfSitesId = groupOfSitesId;
  }

  _createClass(ValidityGroupOfSitesKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ValidityGroupOfSitesKey) {
        var otherKey = other;
        return this.groupOfSitesId === otherKey.groupOfSitesId && this.validFrom.valueOf() === otherKey.validFrom.valueOf() && this.validTo.valueOf() === otherKey.validTo.valueOf();
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.validFrom.valueOf(), "_").concat(this.validTo.valueOf(), "_").concat(this.groupOfSitesId));
    }
  }]);

  return ValidityGroupOfSitesKey;
}();

exports.ValidityGroupOfSitesKey = ValidityGroupOfSitesKey;